import { OnboardingHeader } from './onboarding/onboarding-header';
import { OnboardingSteps } from './onboarding/onboarding-steps';

export function Onboarding() {
    return (
        <div className="flex flex-col h-full">
            <OnboardingHeader />
            <OnboardingSteps />
        </div>
    );
}
